import { render } from "./EditorialCollectionComponent.vue?vue&type=template&id=98fed424&scoped=true"
import script from "./EditorialCollectionComponent.vue?vue&type=script&lang=js"
export * from "./EditorialCollectionComponent.vue?vue&type=script&lang=js"

import "./EditorialCollectionComponent.vue?vue&type=style&index=0&id=98fed424&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98fed424"]])

export default __exports__